import { SVGProps } from 'react';
import { ReactComponent } from 'icons/company-outline.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const CompanyOutline = (props: Props) => (
  // @ts-ignore
  <ReactComponent {...props} alt="company" />
);
